var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08333 4C7.77391 4 7.47717 4.12292 7.25838 4.34171C7.03958 4.5605 6.91667 4.85725 6.91667 5.16667V6.33333H8.08333V5.16667H14.5V11.5833H13.3333V12.75H14.5C14.8094 12.75 15.1062 12.6271 15.325 12.4083C15.5438 12.1895 15.6667 11.8928 15.6667 11.5833V5.16667C15.6667 4.85725 15.5438 4.5605 15.325 4.34171C15.1062 4.12292 14.8094 4 14.5 4H8.08333ZM5.16667 6.91667C4.85725 6.91667 4.5605 7.03958 4.34171 7.25838C4.12292 7.47717 4 7.77391 4 8.08333V14.5C4 14.8094 4.12292 15.1062 4.34171 15.325C4.5605 15.5438 4.85725 15.6667 5.16667 15.6667H11.5833C11.8928 15.6667 12.1895 15.5438 12.4083 15.325C12.6271 15.1062 12.75 14.8094 12.75 14.5V8.08333C12.75 7.77391 12.6271 7.47717 12.4083 7.25838C12.1895 7.03958 11.8928 6.91667 11.5833 6.91667H5.16667ZM5.16667 8.08333H11.5833V14.5H5.16667V8.08333Z",
    fill: "currentColor",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.646f447085361ca758084989cd5073e0.svg";
export { ForwardRef as ReactComponent };